import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';

const initialState = {
  detailNews: null,
  status: 'idle',
  error: null,
};

export const fetchDetailNews = createAsyncThunk(
  'detailNews/fetchDetailNews',
  async ({ slug, previewToken }, { rejectWithValue, signal }) => {
    try {
      const url = previewToken
        ? `${BASE_URL}/v1/news/${slug}/?preview=${previewToken}`
        : `${BASE_URL}/v1/news/${slug}/`;
      const response = await fetch(url, {
        method: 'GET',
        signal,
      });

      if (!response.ok) {
        if (response.status === 404) {
          return rejectWithValue({ notFound: true });
        }
        const errorDetails = await response.json();
        return rejectWithValue(errorDetails);
      }

      return response.json();
    } catch (error) {
      if (error.name === 'AbortError') {
        return rejectWithValue({ aborted: true });
      }
      return rejectWithValue(error.message);
    }
  }
);

const detailNewsSlice = createSlice({
  name: 'detailNews',
  initialState,
  reducers: {
    clearDetailNews: (state) => {
      state.detailNews = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDetailNews.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchDetailNews.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.detailNews = action.payload;
      })
      .addCase(fetchDetailNews.rejected, (state, action) => {
        if (action.payload?.aborted || action.meta.aborted) return;
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearDetailNews } = detailNewsSlice.actions;
export default detailNewsSlice.reducer;
